function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React from 'react';
import { Layer } from 'grommet';
import PropTypes from 'prop-types';
const SideLayer = ({
  setShow,
  data,
  content: Content,
  eventEmitter,
  sideFunctions,
  layerProps = {},
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Layer, _extends({
    full: "vertical",
    position: "right",
    onEsc: () => setShow(false),
    onClickOutside: () => setShow(false)
  }, layerProps), /*#__PURE__*/React.createElement(Content, _extends({
    data: data,
    setShow: setShow,
    eventEmitter: eventEmitter,
    sideFunctions: sideFunctions
  }, rest)));
};
SideLayer.propTypes = {
  setShow: PropTypes.func,
  data: PropTypes.any,
  content: PropTypes.func
};
export default SideLayer;